import ChatFeed from "@/components/ChatFeed";
import { Broadcast } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export default function GlobalFeed() {
  const nav = useNavigate();
  return (
    <div className="p-3 h-[calc(100vh-14rem)] flex flex-col" data-testid="global-feed-page">
      <div className="rounded-2xl bg-gradient-to-br from-purple-500/20 to-[#005CFF]/10 border border-purple-500/30 p-3 mb-3 flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-purple-500/20 flex items-center justify-center">
          <Broadcast size={20} className="text-purple-400" weight="duotone" />
        </div>
        <div>
          <div className="font-display font-semibold">Fil d&apos;actualité</div>
          <div className="text-[10px] text-white/60">Photos, vidéos et messages entre toute l&apos;équipe BKPRO</div>
        </div>
      </div>
      <div className="flex-1 min-h-0">
        <ChatFeed
          chantierId={null}
          placeholder="Partager avec toute l'équipe…"
          title="Fil d'actualité BKPRO"
          onClose={() => nav(-1)}
        />
      </div>
    </div>
  );
}
